import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { SectionHeader } from '@factorialco/f0-react/dist/experimental'
import { CreditCard } from '@factorialco/f0-react/icons/app'
import {
  BenefitBalancesFragment,
  BenefitsValueObjectsBenefitTransactionCategoryEnum,
} from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { CardSidepanel } from 'modules/banking/components/CardSidepanel'
import { BenefitBalancesList } from 'modules/benefits/pages/MyBenefits/BenefitBalancesList'
import SpendingDataCollection from 'modules/benefits/pages/MyBenefits/SpendingDataCollection'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

interface MyBenefitsHomePageProps {
  benefitBalancesList: BenefitBalancesFragment
  benefitCategoriesList: BenefitsValueObjectsBenefitTransactionCategoryEnum[]
  benefitCardId?: number
}

const MyBenefitsHome = ({
  benefitBalancesList,
  benefitCategoriesList,
  benefitCardId,
}: MyBenefitsHomePageProps) => {
  const [showCardSidePanel, setShowCardSidePanel] = useState(false)

  useEffect(() => {
    track(trackingEvents.benefits.openMyBenefitsHomePage)
  }, [])

  const action = benefitCardId
    ? {
        icon: CreditCard,
        label: i18n.t('benefits.my_benefits.spending.card_details_button'),
        onClick: () => setShowCardSidePanel(true),
        variant: 'default' as const,
      }
    : undefined

  return (
    <ResponsivePage.Body showHeader={false} variant="full">
      <SectionHeader
        title={i18n.t('benefits.my_benefits.spending.title')}
        description={i18n.t('benefits.my_benefits.spending.description')}
        action={action}
      />

      <Box paddingTop="s24" />
      <BenefitBalancesList benefitBalancesList={benefitBalancesList} />
      <Box paddingTop="s24" />
      <SpendingDataCollection benefitCategoriesList={benefitCategoriesList} />
      {showCardSidePanel && benefitCardId && (
        <CardSidepanel cardId={benefitCardId} onClose={() => setShowCardSidePanel(false)} />
      )}
    </ResponsivePage.Body>
  )
}

export { MyBenefitsHome }
